import { render, staticRenderFns } from "./V2OrderAddresses.vue?vue&type=template&id=250d0a4c&scoped=true&"
import script from "./V2OrderAddresses.vue?vue&type=script&lang=js&"
export * from "./V2OrderAddresses.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderAddresses.vue?vue&type=style&index=0&id=250d0a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250d0a4c",
  null
  
)

export default component.exports